"use client";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRouter } from "next/navigation"; // Updated import
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SimpelHeader = ({ titel, Icon }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const [i18nextLng, setI18nextLng] = useState(null); // State to store language setting

  // Fetch language setting from localStorage only after component mounts
  useEffect(() => {
    if (typeof window !== "undefined") { // Ensure it's running in the client side
      const storedLang = window.localStorage.getItem('i18nextLng');
      setI18nextLng(storedLang); // Update state with stored language
    }
  }, []); // Run once after component mounts

  if (i18nextLng === null) return null; // Prevent rendering before the language is fetched

  return (
    <nav className="bg-emerald-500 w-full gap-2 px-4 py-6 flex items-center justify-between relative">
      <div className="flex items-center justify-center gap-2">
        <h1 className="text-white text-[20px]   ">{t(titel)}</h1>
        {Icon && <Icon className="h-[30px] w-[30px] text-white" />}
      </div>
      <div
        className={`flex items-center justify-center gap-1 cursor-pointer ${i18nextLng === "en" ? "flex-row-reverse" : "flex-row-reverse"}`}
        onClick={() => router.back()}
      >
        {i18nextLng === "ar" ? (
          <ChevronLeft color="white" size={30} />
        ) : (
          <ChevronRight color="white" size={30} />
        )}
        <p className="text-white text-[20px]  font-bold">{t('common.back')}</p>
      </div>
    </nav>
  );
};

export default SimpelHeader;
